import { useCallback, useEffect, useRef } from 'react';
import type { RefObject } from 'react';
import { ANSWER_TIMEOUT_MS } from '../constants';

type TimeoutRef = RefObject<ReturnType<typeof setTimeout> | null>;

interface IParams {
  isRunning: boolean,
  onTimeout: () => void,
}

const stopTimeout = (timeoutRef: TimeoutRef): void => {
  if (timeoutRef.current) {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = null;
  }
};

const useAnswerTimeout = ({ isRunning, onTimeout }: IParams) => {
  const timeoutRef: TimeoutRef = useRef(null);
  const onTimeoutRef = useRef(onTimeout);

  useEffect(() => {
    onTimeoutRef.current = onTimeout;
  });

  const restart = useCallback((): void => {
    stopTimeout(timeoutRef);
    timeoutRef.current = setTimeout(() => onTimeoutRef.current(), ANSWER_TIMEOUT_MS);
  }, []);

  useEffect(() => {
    if (!isRunning) {
      stopTimeout(timeoutRef);
    }
  }, [isRunning]);

  useEffect(() => () => stopTimeout(timeoutRef), []);

  return { restart };
};

export default useAnswerTimeout;
